export class VacancyApplyHandler {
    resolve = null;
    reject = null;
    popup = null;
    overrideMail = null;
    actionUri = null;
    vacancyApplyButton = null;
    redirectUrlOverride = null;

    constructor(popup, overrideMail, redirectUrlOverride) {
        this.redirectUrlOverride = redirectUrlOverride;
        this.popup = popup;
        this.overrideMail = overrideMail;
        this.handleVacancyApplyButton = this.handleVacancyApplyButton.bind(this);
        this.handleVacancyApplyFormSubmit = this.handleVacancyApplyFormSubmit.bind(this);
    }

    applyToVacancy(actionUri) {
        this.actionUri = actionUri;

        if (this.redirectUrlOverride) {
            // In case the redirect url override is set we can skip the popup and open the url in a new tab.
            // Like this we don't rely on the response of the xhr call for the redirect url, which will
            // make sure we don't trigger safari's popup blocker
            window.open(this.redirectUrlOverride, '_blank');

            // The following call ensures the track clicking is still applied
            return this.fetchPopupTextAndTrackClick();
        }

        return new Promise(async (resolve, reject) => {
            this.resolve = resolve;
            this.reject = reject;
            await this.handleVacancyApplyButton()
            this.popup.open();

            if (this.popup.contentElement.getElementsByClassName('g-recaptcha').length > 0) {
                window.grecaptcha.enterprise.render(this.popup.contentElement.getElementsByClassName('g-recaptcha')[0]);
            }
            initEnterpriseRecapthca(); // execute recaptcha enterprise on popup
            return;
        });
    }

    async handleVacancyApplyButton() {
        if (this.overrideMail !== null) {
            window.open(this.overrideMail);
            this.finish(true);
            return;
        }

        const response = await this.fetchPopupTextAndTrackClick();
        if (response.status === 302) {
            const url = await response.text();
            window.open(url, '_blank');
            this.finish(true);
        }
        this.popup.setContent(await response.text());

    }

    async fetchPopupTextAndTrackClick() {
        const data = new FormData();
        data.set('popupApplyRequest', 'true');
        return await fetch(this.actionUri, {
            method: 'POST',
            header: {
                'content-type': 'application/x-www-form-urlencoded',
            },
            body: data,
        });
    }

    async handleVacancyApplyFormSubmit(e) {
        e.preventDefault();

        try {
            const form = e.target;
            const response = await fetch(form.action, {
                method: 'POST',
                header: {
                    'content-type': 'application/x-www-form-urlencoded',
                },
                body: new FormData(form),
            });

            if (response.status === 204) {
                await this.handleVacancyApplyButton();
            } else {
                this.finish(false);
            }
        } catch (error) {
            this.fail(error);
        }
    }

    finish(success) {
        this.resolve(success);
        this.removeEventListeners();
        this.popup.close();
    }

    fail(error) {
        this.reject(error);
        this.removeEventListeners();
        this.popup.close();
    }

    removeEventListeners() {
        this.popup.getElement().removeEventListener('submit', this.handleVacancyApplyFormSubmit);

        if (this.vacancyApplyButton !== null) {
            this.vacancyApplyButton.removeEventListener('click', this.handleVacancyApplyButton);
        }
    }
}
